import React, {FunctionComponent} from "react"
import {FiPlus} from "react-icons/fi"
import {IoClose, IoCloseOutline} from "react-icons/io5"
import {IconContext} from "react-icons/lib"

interface FilterToggleProps {
	filterName: string
	checked?: boolean
	handleClick?: any
}

const FilterToggle: FunctionComponent<FilterToggleProps> = ({filterName, checked, handleClick}) => {
	return (
		<div
			className={checked ? "filter-toggle-tag filter-tag-active" : "filter-toggle-tag filter-tag-inactive"}
			onClick={handleClick}>
			<div className='filter-tag-text'>{filterName}</div>
			<IconContext.Provider value={{className: `${checked ? "filter-icon--close" : "filter-icon"}`}}>
				{checked ? <IoCloseOutline /> : <FiPlus />}
			</IconContext.Provider>
		</div>
	)
}

export default FilterToggle
